export default "icons-movement-handle"